export function resolveSwitchInReviewFileNameKey(leftCreativeUrl?: string | null, bottomCreativeUrl?: string | null) {
  const hasLeftCreative = Boolean(leftCreativeUrl);
  const hasBottomCreative = Boolean(bottomCreativeUrl);

  if (hasLeftCreative && hasBottomCreative) {
    return 'review.creatives.switchInCombined';
  }

  if (hasLeftCreative) {
    return 'review.creatives.switchInLeftImage';
  }

  return 'review.creatives.switchInBottomImage';
}
